/**
 * Landing page when the app URL is hit without a BC install context.
 * Mostly here so curling the root returns something human-readable
 * instead of a Remix 404.
 */

export default function Index() {
  return (
    <main style={{ fontFamily: "system-ui", maxWidth: 720, margin: "4rem auto" }}>
      <h1>MarketBasketAnalysis for BigCommerce</h1>
      <p>
        This is the backend for the MarketBasketAnalysis BigCommerce app.
        To install, visit the app listing in the BigCommerce App Marketplace.
      </p>
      <p>
        Public API: <code>GET /api/v1/recommendations?product_id=&lt;id&gt;</code>{" "}
        with <code>Authorization: Bearer mba_live_...</code>.
      </p>
    </main>
  );
}
